(function () {
    const clipBtn = document.querySelector('[data-banner-clip-btn]');
    const clipText = document.querySelector('[data-banner-clip-text]');

    if (clipBtn && clipText) {
        clipBtn.addEventListener('click', (e) => {
            e.preventDefault();

            const range = document.createRange();
            const selection = document.getSelection();

            selection.removeAllRanges();
            range.selectNodeContents(clipText);
            selection.addRange(range);
            document.execCommand('copy');
            selection.removeAllRanges();

            const clipConfirm = document.querySelector('[data-banner-clip-confirm]');

            if (clipConfirm) {
                const close = document.querySelector('[data-banner-clip-close]');

                clipConfirm.classList.add('show');

                close.addEventListener('click', (e) => {
                    e.preventDefault();

                    clipConfirm.classList.remove('show');
                })

                setTimeout(() => clipConfirm.classList.remove('show'), 5000);
            }
        })
    }
}());
